import React from 'react';
import { Box, Typography, Button, Container, ThemeProvider, CssBaseline } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Link } from 'react-router-dom';
import { theme } from '../theme/theme';

const PaymentFailure: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container maxWidth="sm">
        <Box
          sx={{
            mt: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            p: 4,
            boxShadow: 3,
            borderRadius: 2,
            bgcolor: 'background.paper',
          }}
        >
          <ErrorOutlineIcon color="error" sx={{ fontSize: 80, mb: 2 }} />
          <Typography variant="h4" component="h1" gutterBottom sx={{ color: theme.palette.text.primary }}>
            ¡Pago Fallido!
          </Typography>
          <Typography variant="body1" align="center" sx={{ mb: 3, color: theme.palette.text.secondary }}>
            Hubo un problema con tu transacción. Por favor, inténtalo de nuevo.
          </Typography>
          <Button variant="contained" color="primary" component={Link} to="/portal">
            Volver al Portal
          </Button>
        </Box>
      </Container>
    </ThemeProvider>
  );
};

export default PaymentFailure;
